import script from "./InProgressCourseCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./InProgressCourseCarousel.vue?vue&type=script&setup=true&lang=js"

import "./InProgressCourseCarousel.vue?vue&type=style&index=0&id=0c4083a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4083a9"]])

export default __exports__